// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';

const otherS = {
  Container: styled.label`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  `,
  Radio: styled.input`
    &:disabled ~ *{
      opacity: 0.5;
    }
  `,
  Label: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #767676;
    margin-left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
}

const S = {
  ...otherS,
  OuterCircle: styled.div`
    border: 2px solid #767676;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    ${otherS.Radio}:checked + &::before {
      content: '';
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #767676;
    }
  `,
}

export { S as default };
